import React from "react";

import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import { Image } from "@arctheme-components/elements/Image/Image";

export function HeaderLogo({ settings, className = "" }) {
  const isMobile = useMobileBreakpoint(settings?.mobile_breakpoint || '1024px');
  const { logo, logo_width, logo_width_mobile, shop_title } = settings.globals;
  const imageWidth = isMobile && logo_width_mobile
    ? logo_width_mobile
    : logo_width || 141;

  // Get the mobile logo size from settings or use default
  const mobileLogoSize = logo_width_mobile || 107;

  return (
    <div
      className={`header-logo-container ${className}`}
      style={{
        '--mobile-logo-size': `${mobileLogoSize}px`,
      }}
    >
      {logo &&
        <a href="/" className="header-logo-image lg:pb-0">
          <Image
            imageUrl={logo}
            alt="Header logo"
            isLazy={true}
            width={imageWidth}
          />
        </a>
      }

      <a href="/" className="header-logo"
        aria-label="Logo">
        {shop_title}
      </a>
    </div>
  );
}
